var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStatusPaused(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 96,
    height: 96,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M-1-1h582v402H-1z"
  })), /*#__PURE__*/React.createElement("circle", {
    stroke: "null",
    cy: 48,
    cx: 48,
    strokeOpacity: "null",
    strokeWidth: "null",
    r: 48,
    style: {
      fill: "#ccc"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    stroke: "null",
    cy: 48,
    cx: 48,
    strokeOpacity: "null",
    strokeWidth: "null",
    r: 34,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "#ccc",
      fillOpacity: 0.97989953
    }
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ccc",
      fillOpacity: 0.97989953,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "M30 28h12v40H30Zm24 0h12v40H54Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStatusPaused);
export default __webpack_public_path__ + "static/media/status-paused.1a4987a73bfad7c27ab21b8e9021e116.svg";
export { ForwardRef as ReactComponent };